export default __webpack_public_path__ + "static/media/countdown_timer.a02be9f8.png";